<template>
  <div class="im-search">
    <div class="im-search__input">
      <input
        type="text" placeholder="Поиск..."
        @keyup.enter="search"
      >
    </div>
    <div
      v-if="items.length > 0"
      class="im-search__result"
    >
      <List
        class="im-search__list"
        :items="items"
        :count="count"
        title="Результаты поиска"
        :opened="true"
        @clickItem="clickUser($event)"
      />
    </div>
    <div v-if="errorMessage" class="im-search__error">Не найдено ни одного
      пользователя
    </div>
  </div>
</template>

<script>
  import List from '../shared/list/List.vue';
  import {dialog} from "../../mixins/dialog";

  export default {
    name: 'Search',
    mixins: [dialog],
    components: {
      List
    },
    data() {
      return {
        errorMessage: false
      };
    },
    computed: {
      items() {
        return this.$store.state.search.items;
      },
      count() {
        return this.$store.state.search.count;
      }
    },
    methods: {
      search(e) {
        const str = e.target.value;
        this.$store.dispatch('exequteSearch', str).then(() => {
          if (this.items.length < 1) {
            this.errorMessage = true;
            setTimeout(() => {
              this.errorMessage = false;
            }, 1500);
          }
        });
      },

      async clickUser(data) {
        const payload = {
          key: 'u'+data.item.id,
          id: data.item.id,
          title: data.item.name,
          value: null,
          users: [data.item],
          group: null
        };
        const existDialog = this.$store.state.dialogs.find(item => item.key === payload.key);
        if (existDialog) {
          await this.$store.dispatch('openDialog', payload);
        } else {
          this.createDialog(payload);
        }
      },
    }
  };
</script>

<style lang="scss">
  .im-search {
    &__input {
      input {
        box-sizing: border-box;
        background: #FFFFFF;
        margin: 0 0 8px;
        border: 1px solid #D6D6D6;
        padding: 12px;
        width: 100%;
        font-size: 13px;
        line-height: 16px;
      }
    }

    &__list {
      border: none;
      margin: 0;
      padding: 12px 0 0;
    }
  }
</style>
